import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { FC, useState } from "react";
import { Presence } from "../../model/Presence";

export const CreatePresenceModal: FC<{
  columns: MRT_ColumnDef<Presence>[];
  onClose: () => void;
  onSubmit: (values: Presence) => void;
  open: boolean;
}> = ({ open, columns, onClose, onSubmit }) => {
  const [values, setValues] = useState<any>(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ""] = "";
      return acc;
    }, {} as any)
  );

  const handleSubmit = () => {
    //put your validation logic here
    onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Ajouter une présence</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "300px", sm: "360px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            {columns.map((column) => (
              <TextField
                key={column.accessorKey}
                label={column.header}
                name={column.accessorKey}
                variant="standard"
                onChange={(e) =>
                  setValues({ ...values, [e.target.name]: e.target.value })
                }
                {...column.muiEditTextFieldProps}
              />
            ))}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" onClick={handleSubmit} variant="contained">
          Ajouter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePresenceModal;
